export const MENU_SECTION = {
  USER: 1,
  SHIPMENTS: 2
}
